<template>

  <v-app>
    <app-menu></app-menu>
    <transition name="clicked-route" mode="out-in">
      <router-view/>
    </transition>
    <v-dialog v-model="locale" width="500">
      <v-card>
        <v-card-title class="headline dark dark-2" primary-title>
          {{ $t('Change Language') }}
        </v-card-title>
        <v-card-text>
          <v-select
            v-model="$i18n.locale"
            :items="languages"
            label="Solo field"
            solo
          ></v-select>
        </v-card-text>
      </v-card>
    </v-dialog>
    <input type="hidden" v-shortkey.once="['ctrl', 'alt', 'l']" @shortkey="toggleLanguage()">
  </v-app>
</template>

<style lang="scss">
  @import 'assets/styles/global.scss';


  .clicked-route-enter,
  .clicked-route-leave-to{
    opacity:0;
  }

  .clicked-route-enter-active{
    transition: all 0.3s ease-out;
  }

  .clicked-route-enter-to,
  .clicked-route-leave{
    opacity:1;

  }

  .clicked-route-leave-active{
     transition: all 0.3s ease-out;
     .section{
       display:none;
     }
  }

</style>

<script>
  import { languages } from "./lang"
  import appMenu  from './components/app-menu.vue'

  export default {
    data() {
      return {
        locale: false,
        languages
      }
    },
    methods: {
      toggleLanguage(){
        this.locale = !this.locale
      }
    },
    components: {
      appMenu
    }
  }

</script>
